module.exports = __webpack_public_path__ + "img/icon4.bc314f3e.png";